import { useQuery } from '@apollo/client';
import { getVisitorWatchlistLevelConfigs } from 'graphql-queries';
import { GetWatchlistLevelConfigsQuery } from 'graphql-query-contracts';

export const useWatchlistLevelConfigs = (channelId: string) => {
  const { data, loading, error, refetch } = useQuery<GetWatchlistLevelConfigsQuery>(getVisitorWatchlistLevelConfigs, {
    variables: {
      filter: {
        organizationId: channelId,
      },
    },
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    skip: !channelId,
  });

  return {
    data: data?.getWatchlistLevelConfigs,
    loading,
    error,
    refetch: async () => {
      const result = await refetch();

      return {
        data: {
          watchlistLevelConfigs: result.data?.getWatchlistLevelConfigs ?? [],
        },
      };
    },
  };
};
